import FolderModel from '@/VueComponents/FileUploadSelector/models/folderModel';
import UploadSelectorFileUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFileUploadModel';
import { FolderUploadType } from '@/VueComponents/FileUploadSelector/enums/folderUploadType';
import { FileUploadType } from '@/VueComponents/FileUploadSelector/enums/fileUploadType';

export default class UploadSelectorFolderUploadModel extends FolderModel {
  type: FolderUploadType;

  constructor(folder: FolderModel, type: FolderUploadType) {
    super(folder.name, folder.files);
    this.type = type;
  }

  public generateFileUploadModels(): UploadSelectorFileUploadModel[] {
    return this.files.map(f => new UploadSelectorFileUploadModel(f, this.getFilesType()));
  }

  private getFilesType(): FileUploadType {
    switch (this.type) {
    case FolderUploadType.cctv:
      return FileUploadType.cctvFile;
    case FolderUploadType.deviceBackup:
      return FileUploadType.deviceBackupFile;
    default:
      return FileUploadType.generalContentFile;
    }
  }
}